// Polyfills
import './utils/_closest.polyfill.js';
import './utils/_matches.polyfill.js';

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Components
import * as bootstrap from 'bootstrap';
/*
import { Collapse, Tooltip, Modal,  Tab, Dropdown} from 'bootstrap';
*/

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import Swiper, { Navigation, EffectFade, Pagination } from 'swiper';


document.addEventListener('DOMContentLoaded', function() {
	let mm = gsap.matchMedia();

	// Get current URL
	const currentUrl = window.location.href;
	//console.log(currentUrl);
	
	var body = document.body;
	var scrollY = window.pageYOffset;
	const burgerBtn = document.getElementById("burgerJS");
	const mainContent = document.getElementById("mainContentJS");

	// GALERIE MASONRY
	var galerieElem = document.querySelector('.page-galerie .block-masonry .grid-item');
	var initResponsiveDesktop = false;
	var initResponsiveMobile = false;
	var galerieMsnryDesktop;
	var galerieMsnryMobile;
	var masonryOptions;

	if (galerieElem) {
		imagesLoaded( document.querySelector('.block-masonry'), function( instance ) {
			//console.log('all images are loaded');
			mm.add("(min-width: 768px)", () => {
				masonryOptions = {
					itemSelector: '.page-galerie .block-masonry .mason-item',
					horizontalOrder: true,
				}

				galerieMsnryDesktop = new Masonry( galerieElem, masonryOptions );

				//console.log(masonryOptions);
			});

			mm.add("(max-width: 767px)", () => {
				masonryOptions = {
					itemSelector: '.page-galerie .block-masonry .mason-item',
					horizontalOrder: false,
				}

				galerieMsnryDesktop = new Masonry( galerieElem, masonryOptions );

				//console.log(masonryOptions);

			});

		
		});
	}

	// BURGER BTN
	mainContent.addEventListener('click', function() {
		if (body.classList.contains('nav-open')) { 
			body.classList.remove('nav-open');
			//document.body.style.height = 'auto';
			bigMenuOpen.reverse();	
		}
	})
	
	burgerBtn.addEventListener('click', function() {		
		if (body.classList.contains('carte-open')) { 
			body.classList.remove('carte-open');
			//document.body.style.height = 'auto';
		
			carteTl.reverse();
			gsap.to(window, {duration: 0.3, scrollTo: 0});
			gsap.to('.carte-popup', {position:'fixed', delay: 0.3});
		} else if (body.classList.contains('page-actu')){
			//history.back();
			//console.log(document.referrer);
		} else {
			if (body.classList.contains('nav-open')) { 
				body.classList.remove('nav-open');
				bigMenuOpen.reverse();
			} else {
				body.classList.add('nav-open');
				bigMenuOpen.play();
			}
		}
	})

	const bigNav = document.getElementById('bigNavJS');
	const bigNavHeight = bigNav.offsetHeight;
	const ribbonTranslate = bigNavHeight - 186;

	const bigMenuOpen = gsap.timeline({paused:true, defaults:{}})
	bigMenuOpen.to('#bigNavJS', {y:0}, "start");

	mm.add("(min-width: 992px)", () => {
		bigMenuOpen.to('.reservation-circle', {y:ribbonTranslate}, "start");
	});

	bigMenuOpen.to('.burger-lines-container .burger-line', {backgroundColor: '#141824'}, "start");
	bigMenuOpen.to('.burger-lines-container .burger-line.--first-line', {rotation:45, y:3}, "start");
	bigMenuOpen.to('.burger-lines-container .burger-line.--second-line', {rotation:-45, y:-3}, "start");
	bigMenuOpen.to('.burger-lines-container .burger-line.--third-line', {opacity:0}, "start");

	const carteBtn = document.getElementById("jsCarteBtn");

	if(carteBtn) {
		bigMenuOpen.to('.carte-popup', {height:0}, "start");
	}

	
	// CONTACT FORM
	var checkbox = document.querySelector('form #rgpd');
	var selectInput = document.getElementById('selectJS');

	if(checkbox) {
		checkbox.addEventListener('click', () => {
			if (checkbox.checked) {
				checkbox.classList.add('checked')
			} else {
				checkbox.classList.remove('checked')
			}
		});

		selectInput.addEventListener('change', () => {
			if(selectInput.value != "firstoption") {
				selectInput.classList.add('checked');
			}
		});
	}
	
	// ROTATE BTN
	const element = document.querySelectorAll(".badge__char");
	const step = 360/element.length;
	
	element.forEach((elem, i) => {
	  elem.style.setProperty('--char-rotate', (i * step) + 'deg');
	})
	
	const foo = (360 / 7);

	// TABS
	const tabsContainer = document.getElementById("tabsContainerJS");
	var scrollAnchor = document.getElementById('jsAnchorMenu');

	if(tabsContainer) {
		//// Carte tabs
		let targets = document.querySelectorAll(".tabs-nav li a");
		let articles = document.querySelectorAll(".tab");
		let activeTab;
		let old;
		let animation;
		var a = window.location.href;
		var firstActiveTab ;
		var firstOldTab;

		for (let i = 0; i < targets.length; i++) {
			targets[i].index = i;
			targets[i].addEventListener("click", doCoolStuff);
		}

		if (window.location.hash.length) {
			for (let i = 0; i < targets.length; i++) {	
				if (a.split('#')[1] === targets[i].dataset.anchor) {	
					firstActiveTab = i;
					firstOldTab = i;

					activeTab = i;
					old = i;
					break;
				}
			}

			mm.add("(min-width: 768px)", () => {
				gsap.set(".slider", {x:targets[firstActiveTab].offsetLeft, width:targets[firstActiveTab].offsetWidth});
			});

			targets[firstActiveTab].style.setProperty('text-decoration-color', '#e6cdb1');
			targets[firstActiveTab].style.setProperty('pointer-events', 'none');
			gsap.set(targets[firstActiveTab], {color:"#e6cdb1"});
			
			articles.forEach((art) => {
				art.style.setProperty('position', 'absolute');
				gsap.set(art, {y:-20, opacity:0}, "start");
			});

			gsap.set(articles[firstActiveTab], {y:0, opacity:1}, "start");
			articles[firstActiveTab].style.setProperty('position', 'relative');
			articles[firstActiveTab].classList.add('show');


			if(carteBtn) {
				var scrollAnchorInfos = scrollAnchor.offsetTop;
		
				window.scrollTo({
					top: scrollAnchorInfos,
					behavior: 'smooth'
				})		
			}

			//console.log('from-reload');

		} else {
			activeTab = 0;
			old = 0;

			mm.add("(min-width: 768px)", () => {
				gsap.set(".slider", {x:targets[0].offsetLeft, width:targets[0].offsetWidth});
			});

			targets[0].style.setProperty('text-decoration-color', '#e6cdb1');
			targets[0].style.setProperty('pointer-events', 'none');
			gsap.set(targets[0], {color:"#e6cdb1"});

			articles.forEach((art) => {
				art.style.setProperty('position', 'absolute');
				gsap.set(art, {y:-30, opacity:0}, "start");
			});

			gsap.set(articles[0], {y:0, opacity:1}, "start");
			articles[0].style.setProperty('position', 'relative');
			articles[0].classList.add('show');

			//console.log('from-nav-btn');
		}
	
		function doCoolStuff() {			
			if(this.index != activeTab) {
				if (animation && animation.isActive()) {
					animation.progress(1);
				}

				animation = gsap.timeline({defaults:{duration:0.3}});
				old = activeTab;
				activeTab = this.index;

				mm.add("(min-width: 768px)", () => {
					animation.to(".slider", {x:targets[activeTab].offsetLeft, width:targets[activeTab].offsetWidth});
				});

				animation.to(targets[old], {color:"#fff", ease:"none"}, 0);
				animation.to(targets[activeTab], {color:"#e6cdb1", ease:"none"}, 0);
				targets[old].style.setProperty('text-decoration-color', '#141824');
				targets[activeTab].style.setProperty('text-decoration-color', '#e6cdb1');
				targets[activeTab].style.setProperty('pointer-events', 'none');

				targets.forEach((tar) => {
					tar.style.setProperty('pointer-events', 'none');
				});

				const animateTab = gsap.timeline({})		
				
				animateTab.eventCallback("onStart", function() {
					articles[activeTab].classList.add('show');
					articles[activeTab].style.setProperty('position', 'relative');
					articles[old].style.setProperty('position', 'absolute');
				});

				animateTab.to(articles[old], {y:30, opacity:0}, "start");

				/*
				var testOut = articles[old].querySelectorAll(".el-container");

				animateTab.to(testOut,
					{
					  y: -30,
					  ease: "Power2.easeInOut",
					  opacity: 0,
					  stagger: 0.3,
					}
				), "start";

				var testIn = articles[activeTab].querySelectorAll(".el-container");

				animateTab.to(testIn,
					{
					  y: 0,
					  ease: "Power2.easeInOut",
					  opacity: 1,
					  stagger: 0.3,
					}
				), "start";
				*/

				animateTab.to(articles[activeTab], {y:0, opacity:1}, "start");

				animateTab.eventCallback("onComplete", function() {
					articles[old].classList.remove('show');

					targets.forEach((tar) => {
						tar.style.setProperty('pointer-events', 'auto');
						targets[activeTab].style.setProperty('pointer-events', 'none');
					});

					if(carteBtn) {
						/*
						var scrollAnchorInfos = scrollAnchor.offsetTop;
						
						window.scrollTo({
							top: scrollAnchorInfos,
							behavior: 'smooth'
						})
						*/
					}
				});
			}
		}

		onresize = (event) => {
			mm.add("(min-width: 768px)", () => {
				gsap.set(".slider", {x:targets[activeTab].offsetLeft, width:targets[activeTab].offsetWidth});
			});
		};
	}
 
	// HOMEPAGE
	//// Scroll and Scale Animation
	const homepageTop = document.getElementById("jsFixedContent");
	const homepageBottom = document.getElementById("jsBottomContent");

	if(homepageTop) {
		const homepageTopHeight = homepageTop.offsetHeight;
		burgerBtn.style.pointerEvents = "none";
		
		gsap.fromTo(".col-homepage-01, .col-homepage-04", {yPercent: -16, opacity:0}, {yPercent: -15, opacity:1, duration: 1.5});
		gsap.fromTo(".col-homepage-02, .col-homepage-05", {yPercent: -19, opacity:0}, {yPercent: -20, opacity:1, duration: 1.5});

		gsap.set(
			'.homepage-logo-yellow', {
				opacity:0, 
				y:-50
			}
		)

		gsap.set(
			'.home .burger-btn-container', {
				opacity:0, 
			}
		)

		const homepageTl = gsap.timeline({
			scrollTrigger: {
				trigger: ".top-homepage",
				start: "top top",
				//end: () => "+=" + homepageTopHeight + "px",
				//end: () => "+=1000px",
				//start: "bottom bottom",
				pin: true,
				scrub: 1.5,
				//markers: true,
				onEnterBack: function() {
					//console.log('enter');
					gsap.to(".homepage-logo-yellow", {opacity:0, y:-50, duration:0.6});
					burgerBtn.style.pointerEvents = "none";
					gsap.to(".home .burger-btn-container", {opacity:0, y:0, duration:0.6, delay:0.6});
				},
				onLeave: function() {
					//console.log('leave');
					gsap.to(".homepage-logo-yellow", {opacity:1, y:0, duration:0.6});
					burgerBtn.style.pointerEvents = "auto";
					gsap.to(".home .burger-btn-container", {opacity:1, y:0, duration:0.6, delay:0.6});
				}
			}
		});

		mm.add("(min-width: 1200px)", () => {
			homepageTl.to(".logo-line-container", {yPercent: -50, duration: 4}, "start");
		});

		mm.add("(max-height: 1099px)", () => {
			homepageTl.fromTo(".col-homepage-01, .col-homepage-04", {yPercent: -15,}, {yPercent: 5, duration: 4}, "start");
			homepageTl.fromTo(".col-homepage-02, .col-homepage-05", {yPercent: -20,}, {yPercent: -40, duration: 4}, "start");
		});

		mm.add("(min-height: 1100px)", () => {
			homepageTl.fromTo(".col-homepage-01, .col-homepage-04", {yPercent: -15,}, {yPercent: -5, duration: 4}, "start");
			homepageTl.fromTo(".col-homepage-02, .col-homepage-05", {yPercent: -20,}, {yPercent: -30, duration: 4}, "start");
		});
		

		homepageTl.fromTo(".col-homepage-03 .brand", {scale:0.06}, {scale:1, duration: 3, delay: 1}, "start");
		
		mm.add("(min-width: 1200px)", () => {
			homepageTl.fromTo(".logo-circle", {opacity: 0}, {opacity: 1, duration: 2, delay: 0.5}, "start");
			homepageTl.fromTo(".logo-circle", {width:"282px", height:"282px"}, {width:"2500px", height:"2500px", duration: 2, delay: 1}, "start");
		});

		homepageTl.fromTo("#jsFixedContent", {opacity: 1}, {opacity: 0, duration: 2, delay: 2}, "start");
		homepageTl.fromTo("#jsBottomContent", {opacity: 0}, {opacity: 1, duration: 2, delay: 2}, "start");
		
		//// Homepage appear animation
		ScrollTrigger.create({
			trigger: '.homepage-logo-yellow-container',
			//pin: true,
			//pinSpacing: false,
			start: () => 'top top',
			endTrigger: '.homepage-nav',
			end: () => 'top top+=300px',
			//markers: true,
			//toggleClass: 'unfixed',
			onEnterBack: function() {
				//console.log('leave');
				gsap.to(".homepage-logo-yellow", {opacity:1, y:0, duration:0.6});
			},
			onLeave: function() {
				//console.log('enter');
				gsap.to(".homepage-logo-yellow", {opacity:0, y:-50, duration:0.6});
			}
		}) 

		//// Random hover position
		const randomPositionClass = ['random-position-01', 'random-position-02', 'random-position-03', 'random-position-04'];
		let randomPosition = randomPositionClass[Math.floor(Math.random() * randomPositionClass.length)];
		let lastPosition = 0;

		const restoLinks = document.querySelectorAll('.resto-link');
		const restoImgContainers = document.querySelector('.images-containers');

		mm.add("(min-width: 1200px)", () => {
			restoLinks.forEach((el) => {
				var restoData = el.dataset.restoNumber;
				const restoImgContainer = restoImgContainers.querySelector(`[data-img-container-number="${restoData}"]`);
				const imgContainers = restoImgContainers.querySelectorAll(`[data-img-container-number="${restoData}"] .img-container`);
				const imgSolo = restoImgContainers.querySelectorAll(`[data-img-container-number="${restoData}"] .img-container img`);

				gsap.set(
					imgContainers, {
						clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
					}
				)

				gsap.set(
					imgSolo, {
						scale: 1.2
					}
				)	
				
				// IMG APPEAR
				const restoTl = gsap.timeline({paused:true, defaults:{duration:0.6, ease: "power2.out", delay: 0.3}})
				let exitTime = 0

				restoTl.to(imgContainers, {
					clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
					y: -100,
				}, 'start')
				restoTl.to(imgSolo, {
					scale: 1
				}, 'start')
				.addPause("exit")
				exitTime = restoTl.duration()
				restoTl.to(imgContainers, {
					clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
				})

				el.addEventListener('mouseenter', (e) => {	
					lastPosition = randomPosition;
					randomPosition = randomPositionClass[Math.floor(Math.random() * randomPositionClass.length)];

					if(randomPosition === lastPosition) {
						randomPosition = randomPositionClass[Math.floor(Math.random() * randomPositionClass.length)];
					}

					restoImgContainer.setAttribute("data-random", randomPosition);
					
					if(restoTl.time() < exitTime){
						restoTl.play();
					} else {
						restoTl.restart()
					}
				})	
				
				el.addEventListener('mouseleave', (e) => {
					if(restoTl.time() < exitTime){
						restoTl.reverse();
					} else {
						restoTl.play();
					}
				})
			})
		});
	}	

	// RESTAURANT
	//// Carte btn
	const carteTl = gsap.timeline({paused:true, defaults:{}})

	if(carteBtn) {
		// FIRST APPEAR
		const restaurantInfos = document.getElementById("restaurantInfoJS");
		const restaurantGalerie = document.getElementById("restaurantGalerieJS");
		const restaurantEvent = document.getElementById("restaurantEventJS");

		const tl0 = gsap.timeline();

		tl0.to('.navbar-restaurant-title', {
			opacity: 1,
		});		

		if(restaurantInfos) {
			let elementLeft = gsap.utils.toArray("#restaurantInfoJS .elementLeftJS");
			let elementRight = gsap.utils.toArray("#restaurantInfoJS .elementRightJS");

			const tl1 = gsap.timeline();	
			const tl2 = gsap.timeline();	
			tl0.add(tl1);	
			tl0.add(tl2);

			tl1.to(elementLeft, {
				opacity: 1,
				translateY: 0,
				stagger: 0.075,
			});

			tl2.to(elementRight, {
				opacity: 1,
				stagger: 0.175,
			});
		}

		if(restaurantGalerie) {
			var sections = gsap.utils.toArray('#restaurantGalerieJS .mason-item .item-container');

			tl0.eventCallback("onComplete", function() {
				sections.forEach((section) => {
					gsap.to(section, { autoAlpha: 1, y:0,
					  scrollTrigger: {
						  trigger: section,
						  start: 'top top+=508',
						  //scrub: true,
						  end: '+=500',
						  //markers: true
						}
					});
				})
			});
		}

		if(restaurantEvent) {
			let eventHeaderImg = gsap.utils.toArray("#restaurantEventJS .header .img-container");
			let eventFooterImg = gsap.utils.toArray("#restaurantEventJS .footer .img-container");

			const tl1 = gsap.timeline();	
			tl0.add(tl1);		
			
			tl1.to(eventHeaderImg, {
				opacity: 1,
				translateY: 0,
				stagger: 0.075,
			});
			
			tl1.to('#restaurantEventJS .logo-container', {
				opacity: 1,
				translateY: 0,
			}, '-=.2');

			tl1.to('#restaurantEventJS .body', {
				opacity: 1,
				translateY: 0,
			}, '-=.4');

			tl1.to(eventFooterImg, {
				opacity: 1,
				translateY: 0,
				stagger: 0.075,
			});
		}

		// POPUP		
		carteTl.to('body', {backgroundColor: '#EDDCC8'}, "start");
		carteTl.to('.navbar-restaurant', {opacity: 0}, "start");
		carteTl.to('.main-content', {opacity: 0, y:10}, "start");
		carteTl.to('.navbar-content-carret, footer', {opacity: 0}, "start");

		carteTl.to('.main-content, footer', {
			display: 'none',
		}, "start");

		carteTl.to('.burger-lines-container .burger-line', {backgroundColor: '#141824'}, "start");
		carteTl.to('.burger-lines-container .burger-line.--first-line', {rotation:45, y:3}, "start");
		carteTl.to('.burger-lines-container .burger-line.--second-line', {rotation:-45, y:-3}, "start");
		carteTl.to('.burger-lines-container .burger-line.--third-line', {opacity:0}, "start");

		carteTl.to('.main-wrapper', {backgroundColor: '#EDDCC8'}, "start");
		carteTl.to('.navbar-restaurant-title h1', {color: '#141824'}, "start");
		carteTl.to('.logo-intern svg path', {fill: "#141824"}, "start");
		
		carteTl.to('.carte-popup', {duration: 0, opacity:1});
		carteTl.to('.carte-popup', {duration: .6, y:0});

		carteTl.to('.trace-shape svg', {opacity: 0}, "start");
		carteTl.to('.trace-shape svg path', {fill: "#E6CDB1"}, "start");
		carteTl.to('.trace-shape svg', {opacity: 1}, "-=.5");

		carteBtn.addEventListener('click', function() {
			body.classList.add('carte-open');
			gsap.to(window, {duration: 0.3, scrollTo: 0});
			gsap.to('.carte-popup', {position:'absolute'});
			
			carteTl.play();
		})

		if (window.location.hash.length) {
			body.classList.add('carte-open');
			gsap.to('.carte-popup', {position:'absolute'});

			carteTl.play();		
		}
	}

	// INTERN TINY NAV
	const navbarSecond = document.getElementById("navbarSecondJS");

	if(navbarSecond) {
		gsap.to('#navbarSecondJS', {
			opacity: 1,
			translateY: 0,
		});
	}

	const titleIntern = document.getElementById("appearAnimJS");
	
	if(titleIntern) {
		gsap.to('#appearAnimJS', {
			opacity: 1,
			translateY: 0,
		});
	}	
	setTimeout(() => {
		ScrollTrigger.refresh(); 
	}, 1000)
})
